<script>

import {axios} from '../mixins';
import Modal from './Modal.vue';
import {Alerts} from '../mixins/Alerts.js';

export default {

  name: 'Help',

  components: {Modal},

  mixins: [axios],

  props: {
    url: {
      required: true,
      type: String,
      default: null,
    },
    enterEmail: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      responseMessage: '',
      alerts: new Alerts(),
      formattedErrors: [],
      status: null,
      email: null,
      message: null,
      subject: null,
    };
  },

  computed: {},

  methods: {
    submit: function () {
      this.alerts.initialize()
      let data = {
        'subject': this.subject,
        'message': this.message,
        'email': this.email,
      }
      this.post('/contact', data).then((response) => {
        this.status = 'sent'
        this.subject = null
        this.message = null
        console.log(response.data.message)
        this.responseMessage = response.data.message
        this.$refs.contactModal.close();
      }).catch((err) => {
        // check modal is still open
        if (this.$refs.contactModal.showModal) {
          if (err.response.data.errors) {
            this.alerts.recordErrors(err.response.data.errors)
          }
        }
      })
    },
  },
};

</script>

<template>

  <div class="text-right">
    <p class="text-green mb-2" v-if="responseMessage">
      <i class="fas fa-check-circle"></i><span class="ml-2">{{ responseMessage }}</span>
    </p>
    <Modal :small="true" ref="contactModal">
      <div class="flex flex-col bg-grey-darker w-full p-4 text-white">

        <div class="font-bold text-xl">
          Email Us
        </div>
        <div>
          <p class="text-lg">
            Have questions? Send us a message or checkout our <a :href="url" class="text-blue-light hover:text-blue" target="_blank"> Farmer Onboarding
            Guide</a>.
          </p>

        </div>
        <form @submit.prevent="submit" method="post">
          <div class="flex flex-row flex-wrap flex-1 items-center my-1">
            <label for="subject" class="font-semibold">Subject</label>
            <input name="subject"
                   id="subject"
                   v-model="subject"
                   class="bg-grey italic text-white border-b py-2 border-grey-light w-full px-3 leading-tight focus:outline-none focus:bg-grey-light text-md"
                   type="text"
                   maxlength="50">
          </div>
          <div class="text-red">
            {{ alerts.getError('subject') }}
          </div>
          <div v-if="enterEmail" class="flex flex-row flex-wrap flex-1 items-center my-1">
            <label for="email" class="font-semibold">Email</label>
            <input name="email"
                   id="email"
                   v-model="email"
                   class="bg-grey italic text-white border-b py-2 border-grey-light w-full px-3 leading-tight focus:outline-none focus:bg-grey-light text-md"
                   type="email"
                   maxlength="50">
          </div>
          <div class="text-red">
            {{ alerts.getError('email') }}
          </div>


          <div class="flex flex-row flex-wrap flex-1 my-1">
            <label for="message" class="font-semibold">Message</label>
            <textarea name="message"
                      id="message"
                      v-model="message"
                      rows="8"
                      class="bg-grey italic text-white border-b py-2 border-grey-light w-full px-3 leading-tight focus:outline-none focus:bg-grey-light text-md"
                      maxlength="900">
            </textarea>
          </div>
          <div class="text-red">
            {{ alerts.getError('message') }}
          </div>
        </form>
      </div>

      <template #toggle="{open}">
        <button
            v-on:click="open"
            class="px-6 py-1 rounded-sm text-white inline-block shadow-lg bg-blue hover:bg-blue-dark focus:bg-blue-darker mt-2 font-bold mr-2"
            type="button" name="Validate Contract">
          <i class="fas fa-flip-horizontal fa-comment"></i>
          <span class="ml-2 font-semibold self-center">Help?</span>
        </button>
      </template>

      <template #footer="{close,cancel}">
          <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
            <button
                class="px-6 py-1 rounded-sm text-white inline-block shadow-lg bg-green hover:bg-green-dark focus:bg-green-darker mt-2 font-bold mr-1 mr-1 mr-2"
                type="button" name="Submit Message" @click="submit">Send Message
            </button>
          </span>

        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <button type="button"
                    class="px-6 py-1 rounded-sm text-white inline-block shadow-lg bg-grey-light hover:bg-grey focus:bg-grey-darker mt-2 font-bold mr-2"
                    v-on:click="cancel">
              {{ !(status === 'submitted') ? 'Cancel' : 'Close' }}
            </button>
          </span>
      </template>
    </Modal>
  </div>

</template>
